// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainSection_mainContainer__GzUVW"};